// Multi-Room Editing Drawer
// User ctrl-clicks to add rooms to multiSelectRoomArray ("mouse-up" on esri-map.vue)
// It will not show unless user is a manager of at least one dept.
// An array of roomKeys ("300A+A316") is sent along with an object describing properties to change
// All rooms in array are updated with any properties that are not NULL.  NULL properties are ignored.
// multiSelectRoomArray is cleared on empty map click.

<template>
	<LeftSidebar v-if="allowManagerUI || allowOccupantEditorUI" :open="BulkRoomEditSideBarOpen" 
		:updateSidebar="updateBulkRoomEditSideBar" width="750"
		:class="{ 'white' : !darkTheme, 'grey darken-2' : darkTheme }" 
		:lowerTitle="true"
		:actionIcon="'highlight_alt'"
        :actionFunction="useSelectRectangle"
        :actionTooltip="'Lasso Selection Tool'" 
		dark
		:toolbarColor="'indigo darken-4'"
		style="z-index: 32 !important"
		:style="usingDashboard ? 'width: 25vw;' : 'width: 750px;'"
		>
		
		<div slot="sbTitle" >
			Bulk Room Editor
    	</div> 

    	<div slot="sbContent" class="caption pt-4">
    		<BulkRoomEditSideBarContent :key="reset"/>
    	</div>	    
	</LeftSidebar>
</template>

<script>

import { mapMutations, mapActions, mapState, mapGetters } from 'vuex'
import LeftSidebar from './LeftSidebar'
import BulkRoomEditSideBarContent from './BulkRoomEditSideBarContent'

export default {

	data() {
  		return {
  			reset: 1,		// This is a hack used to reset children
  		}
	},

	components : { LeftSidebar, BulkRoomEditSideBarContent },

	watch: {
		BulkRoomEditSideBarOpen (val) { if (!val) { this.reset = this.reset +1 } },
	},

	computed: {

		...mapState({
			BulkRoomEditSideBarOpen: state => state.ui.BulkRoomEditSideBarOpen,
			darkTheme: state => state.ui.darkTheme,
			userManagedDepts: state => state.user.userManagedDepts,
		}),

	    isSpaceManager: function () {
			if (this.userManagedDepts.length > 0) {	return true	}
		},

		usingDashboard: function () {
			if (this.$route.path.includes('dashboard')) {
				return true
			} else { return false }
		},

		...mapGetters(['allowManagerUI', 'allowOccupantEditorUI']),

	},

	methods: {
	  	...mapMutations([	'updateBulkRoomEditSideBar',	  						]),
	  	...mapActions([ 'useSelectRectangle'])
	}						
}

</script>


<style>
</style>





// WEBPACK FOOTER //
// src/components/BulkRoomEditSideBar.vue